import React, { useState, useEffect } from "react";
import Header from "./Header";
import api from "../api/api"; // adjust path
import * as XLSX from "xlsx";

export default function OrderSummary() {
  const today = new Date().toISOString().split("T")[0];
  const [selectedDate, setSelectedDate] = useState(today);
  const [searchText, setSearchText] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");


  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState([]);
  const [popupLoading, setPopupLoading] = useState(false);

  const handleItemClick = async (item) => {
    setShowPopup(true);
    setPopupLoading(true);
    try {
      const res = await api.OnlineOrderItemSummary(selectedDate, item.itemid);
      setPopupData(res.OnlineOrderItemSummaryjs?.Table || []);
    } catch (err) {
      console.error(err);
      setPopupData([]);
    } finally {
      setPopupLoading(false);
    }
  };



  useEffect(() => {
    const user = sessionStorage.getItem("username");
    if (!user) {
      alert("Session expired. Please log in again.");
      // Assuming there's a setIsLoggedIn prop or something, but since it's not, maybe just set to empty
      setUsername("");
    } else {
      setUsername(user);
    }
  }, []);

  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await api.OnlineOrderSummary(selectedDate);
        const tableData = res.OnlineOrderSummaryjs?.Table || [];

        const mappedData = tableData.map((item) => ({
          date: item.deliverydate.split("T")[0],
          foodType: item.FoodType,
          itemName: item.item_desc,
          qty: item.qty,
          itemid: item.itemid
        }));

        setData(mappedData);
      } catch (error) {
        console.error("Error fetching data:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedDate]);



  // Filter data based on search
  const filteredData = data.filter(
    (item) =>
      searchText === "" ||
      item.foodType.toLowerCase().includes(searchText.toLowerCase()) ||
      item.itemName.toLowerCase().includes(searchText.toLowerCase())
  );

  // Export to Excel
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "OrderSummary");
    XLSX.writeFile(wb, `OrderSummary_${selectedDate}.xlsx`);
  };

  const exportPopupToExcel = () => {
    if (popupData.length === 0) return;

    const exportData = popupData.map((row) => ({
      "Order No": row.oid,
      "Customer Name": row.Vname,
      "Item": row.item_desc,
      "Qty": row.Qty,
      "Circle": row.Division,
      "Amount": row.amount
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "ItemOrderDetails");
    XLSX.writeFile(
      wb,
      `Item_Order_Details_${selectedDate}.xlsx`
    );
  };


  // Back button handler
  const handleBack = () => {
    window.history.back();
  };

const totalQty = popupData.reduce(
  (sum, row) => sum + Number(row.Qty || 0),
  0
);

const orderCount = popupData.length;

const itemTitle =
  popupData.length > 0
    ? `${popupData[0].item_desc} `
    : "";


  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="p-2 md:ml-64">
       

        <div className="bg-white shadow-2xl rounded-2xl p-6 max-w-8xl">
          {/* Header Section */}
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 border-b pb-3 mb-4">
            <button
              onClick={handleBack}
              className="inline-flex items-center gap-1 px-3 py-1 text-gray-800 font-semibold
                 bg-gray-200 hover:bg-gray-300 rounded-full shadow transition
                 text-sm sm:text-base w-auto self-start"
            >
              ← Back
            </button>

            <h1 className="text-xl sm:text-3xl font-bold text-orange-600 text-center flex-1">
              Order Summary
            </h1>

            <button
              onClick={exportToExcel}
              className="px-2 py-1 font-semibold inline-flex w-auto self-start text-white bg-blue-500 hover:bg-blue-700 rounded-full shadow transition"
            >
              📄 Export Excel
            </button>
          </div>

          {/* Filters Section */}
          <div className="flex flex-col md:flex-row gap-4 mb-4 items-center">
            {/* Date Picker */}
            <label className="flex items-center gap-2 text-gray-800 font-medium  ">
              <span className="ml-10  ">Date:</span>
              <input
                type="date"
                className="p-2 rounded border border-orange-300 text-gray-800 focus:outline-none focus:ring-2 focus:ring-orange-400"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />
            </label>

            {/* Search Box */}
            <div className="flex-1 flex justify-end">
              <input
                type="text"
                placeholder="🔍Search Food Type or Item Name"
                className="w-full sm:w-1/3 px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
          </div>

          {/* Table Section */}
          <div className="overflow-x-auto border border-gray-200 rounded-xl shadow-inner">
            <table className="min-w-full text-sm text-gray-700">
              <thead className="sticky top-0 bg-gradient-to-r from-orange-500 to-orange-500 text-white">
                <tr>
                  {["Date", "Food Type", "Item Name", "Qty"].map(
                    (header, index) => (
                      <th
                        key={index}
                        className={`p-3 border border-orange-500 ${index === 0 || index === 4 ? "text-left" : "text-left"
                          }`}
                      >
                        {header}
                      </th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan="5"
                      className="p-4 text-center text-orange-500  "
                    >
                      Loading...
                    </td>
                  </tr>
                ) : filteredData.length === 0 ? (
                  <tr>
                    <td
                      colSpan="5"
                      className="p-4 text-center text-gray-500 border border-gray-300"
                    >
                      No items found
                    </td>
                  </tr>
                ) : (
                  filteredData.map((item, index) => (
                    <tr
                      key={index}
                      className={`transition hover:bg-orange-50 ${index % 2 === 0 ? "bg-white" : "bg-gray-50"
                        }`}
                    >

                      <td className="p-3">
                        {new Date(item.date).toLocaleDateString("en-GB")} {/* DD-MM-YYYY */}
                      </td>
                      <td className="p-3 ">
                        {item.foodType}
                      </td>
                      <td
                        className="p-3 text-blue-600 cursor-pointer underline"
                        onClick={() => handleItemClick(item)}
                      >
                        {item.itemName}
                      </td>

                      <td className="p-3  ">
                        {item.qty}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </main>

      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-3xl p-5">

           <div className="mb-4">
  {/* Header */}
  <div className="flex justify-between items-center">
    <h2 className="text-xl font-bold text-orange-600">
      Item Order Details
    </h2>

    <div className="flex gap-2">
      <button
        onClick={exportPopupToExcel}
        className="px-2 py-1 font-semibold inline-flex text-white bg-blue-500 hover:bg-blue-700 rounded-full shadow transition"
      >
        📄 Export
      </button>

      <button
        onClick={() => setShowPopup(false)}
        className="px-3 py-1.5 text-sm font-medium bg-white text-orange-600 rounded-lg hover:bg-orange-100 hover:scale-105 transition"
      >
         ✖
      </button>
    </div>
  </div>

  {/* Item Summary */}
  {popupData.length > 0 && (
    <div className="mt-3 p-3 bg-orange-50 rounded-lg border border-orange-200 text-sm flex flex-wrap gap-6">
      <div>
        <span className="font-semibold text-gray-700">Item :</span>{" "}
        <span className="font-bold text-gray-800">{itemTitle}</span>
      </div>

      <div>
        <span className="font-semibold text-gray-700">Total Qty :</span>{" "}
        <span className="text-gray-900">{totalQty}</span>
      </div>

      <div>
        <span className="font-semibold text-gray-700">Order Count :</span>{" "}
        <span className="text-gray-900">{orderCount}</span>
      </div>
    </div>
  )}
</div>



            {popupLoading ? (
              <div className="text-center text-orange-500">Loading...</div>
            ) : popupData.length === 0 ? (
              <div className="text-center text-gray-500">No data found</div>
            ) : (
              <table className="min-w-full border text-sm">
                <thead className="bg-orange-500 text-white">
                  <tr>
                    <th className="p-2 border">Ord No</th>
                    <th className="p-2 border">Customer Name</th>
                    <th className="p-2 border">Item</th>
                    <th className="p-2 border">Qty</th>
                    <th className="p-2 border">Division</th>
                    <th className="p-2 border">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {popupData.map((row, i) => (
                    <tr key={i} className="hover:bg-orange-50">
                      <td className="p-2 border text-right">{row.oid}</td>
                      <td className="p-2 border">{row.Vname}</td>
                      <td className="p-2 border">{row.item_desc}</td>                      
                      <td className="p-2 border text-right">{row.Qty}</td>
                      <td className="p-2 border">{row.Division}</td>
                      <td className="p-2 border">{row.amount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      )}

    </div>
  );
}
